import { makeVar } from '@apollo/client'
import type { ConsentChoice } from './types'
import { readConsentCookie } from './utils/consent-cookie'

/**
 * Current cookie choice; `null` until the visitor decides (or after a policy
 * version bump). Seeded from the cookie at module load so the banner and
 * `ConsentEffect` see a stored choice on the first render.
 */
export const consentVar = makeVar<ConsentChoice | null>(readConsentCookie())

export const isConsentDialogOpenVar = makeVar(false)
